"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueBase = void 0;
const tslib_1 = require("tslib");
const api_1 = require("./api");
const filters_1 = tslib_1.__importDefault(require("./filters"));
const registries_1 = require("./registries");
const version_1 = require("./version");
const emptyBootOptions = {
    assets: {},
    components: {},
    configs: {},
    filters: {},
    fonts: {},
    plugins: [],
    themes: [],
};
class BlueBase {
    constructor() {
        /** BlueBase Version */
        this.version = version_1.VERSION;
        // APIs
        this.Analytics = new api_1.Analytics(this);
        this.Logger = new api_1.Logger(this);
        // Registries
        this.Assets = new registries_1.AssetRegistry(this);
        this.Components = new registries_1.ComponentRegistry(this);
        this.Configs = new registries_1.ConfigRegistry(this);
        this.Filters = new registries_1.FilterRegistry(this);
        this.Fonts = new registries_1.FontRegistry(this);
        this.Plugins = new registries_1.PluginRegistry(this);
        this.Themes = new registries_1.ThemeRegistry(this);
        // Flags
        this.booted = false;
        this.bootOptions = emptyBootOptions;
        /**
         * Performs boot, and resets whole view heirarchy
         */
        this.reboot = async (reset) => {
            // This is just a stub funnction. It is replaced by BlueBaseApp
            this.boot({ reset });
        };
        this.onProgress = () => {
            return;
        };
    }
    async boot(_a = {}) {
        var { onProgress } = _a, options = tslib_1.__rest(_a, ["onProgress"]);
        // Store onProgress for later use, even after boot finishes (i.e. in reboot, etc)
        if (onProgress) {
            this.onProgress = onProgress;
        }
        this.onProgress({
            message: 'Initiating...',
            progress: 0,
        });
        try {
            await this.bootInternal(options);
        }
        catch (error) {
            this.onProgress({ error });
        }
        return this;
    }
    /**
     * Performs a reset and boot. Does not unmount the whole app.
     */
    async reset(options) {
        return this.boot(Object.assign(Object.assign({}, options), { reset: true }));
    }
    /**
     * Main boot business logic
     * @param param
     */
    async bootInternal(_a) {
        var { reset } = _a, options = tslib_1.__rest(_a, ["reset"]);
        const onProgress = this.onProgress;
        // Update boot options
        this.bootOptions = Object.assign(Object.assign({}, this.bootOptions), options);
        if (reset === true) {
            await this.Filters.run('bluebase.reset', this.bootOptions, { onProgress });
            onProgress({
                message: 'Reseting...',
                progress: 10,
            });
        }
        // Register basic filters here, so they can be used in boot
        await this.Filters.registerNestedCollection(filters_1.default);
        onProgress({
            message: 'Loading system defaults',
            progress: 20,
        });
        // 🚀 Boot!
        await this.Filters.run('bluebase.boot', this.bootOptions, { onProgress });
        // Set booted flag
        this.booted = true;
        onProgress({
            message: 'Done!',
            progress: 100,
        });
        return this;
    }
}
exports.BlueBase = BlueBase;
